import React, { useState } from "react";
import { FaUsers, FaClipboardList, FaCogs, FaCalendarAlt, FaTasks, FaLock } from "react-icons/fa";

const menuStructure = [
  {
    title: "MASTER INFO",
    items: [
      { label: "General Info", icon: <FaUsers />, key: "general_info" },
      { label: "Billing", icon: <FaClipboardList />, key: "billing" },
      { label: "Services", icon: <FaCogs />, key: "services" },
      { label: "Notes", icon: <FaCalendarAlt />, key: "notes_master" },
    ],
  },
  {
    title: "RELATIONSHIP MGT",
    items: [
      { label: "Tracking", icon: <FaClipboardList />, key: "tracking" },
      { label: "Tasks", icon: <FaTasks />, key: "tasks" },
      { label: "Notes", icon: <FaCalendarAlt />, key: "notes_relationship" },
    ],
  },
  {
    title: "PROJECT",
    items: [
      { label: "Projects", icon: <FaUsers />, key: "projects" },
      { label: "Job", icon: <FaClipboardList />, key: "job" },
      { label: "Notes", icon: <FaCalendarAlt />, key: "notes_project" },
    ],
  },
  {
    title: "ACCESS CONTROL",
    items: [
      { label: "Manage Access", icon: <FaLock />, key: "manage_access" },
      { label: "Job", icon: <FaClipboardList />, key: "job_access" },
    ],
  },
];

const SidebarLayout = () => {
  const [activeKey, setActiveKey] = useState(null);
  const [activeItem, setActiveItem] = useState(null);
  const [collapsedGroups, setCollapsedGroups] = useState({});

  const handleSelect = (item) => {
    setActiveKey(item.key);
    setActiveItem(item);
  };

  const toggleGroup = (title) => {
    setCollapsedGroups((prev) => ({
      ...prev,
      [title]: !prev[title],
    }));
  };

  return (
    <div className="flex h-screen font-sans text-sm">
      {/* LEFT SIDEBAR */}
      <div className="w-[260px] border-r bg-white shadow-sm flex flex-col">
        <div className="p-4 border-b bg-gray-50">
          <h2 className="text-lg font-semibold text-gray-800">{activeItem ? activeItem.label : "Select Section"}</h2>
        </div>
        <div className="overflow-auto flex-1">
          {menuStructure.map((group) => (
            <div key={group.title} className="border-b last:border-none">
              <div
                className="flex items-center justify-between px-3 py-2 bg-gray-100 text-gray-700 font-semibold cursor-pointer"
                onClick={() => toggleGroup(group.title)}
              >
                <span>{group.title}</span>
                <span>{collapsedGroups[group.title] ? "+" : "-"}</span>
              </div>
              {!collapsedGroups[group.title] && (
                <div className="flex flex-col">
                  {group.items.map((item) => (
                    <button
                      key={item.key}
                      className={`flex items-center gap-2 px-4 py-2 text-left hover:bg-gray-100 ${
                        activeKey === item.key ? "bg-gray-200 text-blue-900 font-semibold" : "text-gray-600"
                      }`}
                      onClick={() => handleSelect(item)}
                    >
                      {item.icon}
                      <span>{item.label}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* RIGHT CONTENT */}
      <div className="flex-1 p-6 overflow-auto">
        {activeItem ? (
          <div>
            <h1 className="text-2xl font-bold mb-4">{activeItem.label}</h1>
            <p>
              You're now viewing the <strong>{activeItem.label}</strong> section.
            </p>
            {/* You can insert custom components here based on activeItem.key */}
          </div>
        ) : (
          <p className="text-gray-500">Choose something from the left panel.</p>
        )}
      </div>
    </div>
  );
};

export default SidebarLayout;
